/* eslint-disable no-nested-ternary */
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import $ from 'jquery'
import { useTranslation } from 'react-i18next'
import { Card, Tooltip, Collapse, AccordionDetails } from '@mui/material'
import { styled } from '@mui/material/styles'
import IconButton from '@mui/material/IconButton'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

import { setFlowGroupAttributeTab } from '../../../../actions'
import { Logger, LoggerTypes } from '../../../../utils'
import './style.scss'

const ExpandMore = styled((props) => {
  const { ...other } = props
  return <IconButton {...other} />
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest
  })
}))

export const FlowTaskCard = ({ task }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [expanded, setExpanded] = useState(false)

  const name = task?.name || ''
  const description = task?.description || ''

  const instances = task?.instances || null
  // -- sort the array of object to prevents from changing the display order.
  // -- the backend doesn't always returns the data in the same order.
  if (instances) {
    instances.sort((a, b) => (a.element_id > b.element_id ? 1 : -1))
  }

  const errorOverClassName = '__elementErrorOver'
  const centerElement = $('.commonPage_container_central.twoSections')
  const rightElement = $('.commonPage_container_lateral.right')

  const onExpandClick = () => {
    setExpanded(!expanded)
  }

  const onTaskInstanceClick = (e, element_id) => {
    e.preventDefault()
    e.stopPropagation()

    Logger.trace(LoggerTypes.CONTROLLER, 'FlowTaskCard.onTaskInstanceClick()', { element_id })

    rightElement.removeClass('close').addClass('open')
    centerElement.removeClass('close').addClass('open')

    dispatch(setFlowGroupAttributeTab(element_id, { type: 'bpmn:Task', id: element_id }))
  }

  const onTaskInstanceOver = (e, element_id) => {
    e.preventDefault()
    e.stopPropagation()

    const _el = $(`[data-element-id="${element_id}"]`)
    const _elLabel = $(`[data-element-id="${element_id}_label"]`)

    // Logger.trace(LoggerTypes.CONTROLLER, 'FlowTaskCard.onTaskInstanceOver()', { element_id })

    if (_el) {
      _el.addClass(errorOverClassName)
      if (_elLabel) {
        _elLabel.addClass(errorOverClassName)
      }
    }
  }

  const onTaskInstanceOut = (e, element_id) => {
    e.preventDefault()
    e.stopPropagation()

    const _el = $(`[data-element-id="${element_id}"]`)
    const _elLabel = $(`[data-element-id="${element_id}_label"]`)

    // Logger.trace(LoggerTypes.CONTROLLER, 'FlowTaskCard.onTaskInstanceOut()', { element_id })

    if (_el) {
      _el.removeClass(errorOverClassName)
      if (_elLabel) {
        _elLabel.removeClass(errorOverClassName)
      }
    }
  }

  // --

  // Logger.trace(LoggerTypes.CONTAINER, 'FlowTaskCard.render()', {
  //   task
  // })

  return (
    <Card className="FlowTaskCard common-card">
      {instances && instances.length > 1 ? (
        <>
          <Tooltip title={description}>
            <div className="taskName" onClick={onExpandClick}>
              <b>{name}</b>
            </div>
          </Tooltip>
          <ExpandMore className="btExpand" expand={expanded} onClick={onExpandClick} aria-expanded={expanded}>
            <ExpandMoreIcon />
          </ExpandMore>
          <Collapse className="expander" in={expanded} timeout="auto" unmountOnExit>
            {instances.map((el, index) => (
              <AccordionDetails
                key={`task-instance-${index}`}
                className="taskInstanceRow"
                onClick={(e) => onTaskInstanceClick(e, el.element_id)}
                onMouseOver={(e) => onTaskInstanceOver(e, el.element_id)}
                onMouseOut={(e) => onTaskInstanceOut(e, el.element_id)}
              >
                <b>{`0${index + 1} - ${t('flowGroups.left.tabs.actions.tasks.instance')}`}</b>
                {/* {el.element_id} */}
              </AccordionDetails>
            ))}
          </Collapse>
        </>
      ) : instances.length === 1 ? (
        <Tooltip title={description} className="expander">
          <div
            style={{ padding: '0 5px 5px' }}
            className="taskInstanceRow"
            onClick={(e) => onTaskInstanceClick(e, instances[0].element_id)}
            onMouseOver={(e) => onTaskInstanceOver(e, instances[0].element_id)}
            onMouseOut={(e) => onTaskInstanceOut(e, instances[0].element_id)}
          >
            <b>{name || instances[0].element_id}</b>
          </div>
        </Tooltip>
      ) : (
        <b>None</b>
      )}
    </Card>
  )
}

FlowTaskCard.displayName = 'FlowTaskCard'

FlowTaskCard.propTypes = {
  task: PropTypes.object.isRequired
}

FlowTaskCard.defaultProps = {
  task: null
}
